export const SALES_WORKSPACE_ACADEMY_SHORT_ID = 2639660;
export const CREATE_LEADS_ACADEMY_SHORT_ID = 4784785;
export const LANDING_PAGES_SHORT_ID_QA = 1000628;
export const PRACTICE_MODE_CONFIG = {
  [SALES_WORKSPACE_ACADEMY_SHORT_ID]: {
    toolPath: 'prospecting',
    upgradePoint: 'sales-workspace-academy',
    scope: 'prospecting-workspace-access'
  },
  [CREATE_LEADS_ACADEMY_SHORT_ID]: {
    toolPath: 'prospecting',
    upgradePoint: 'create-leads-academy',
    scope: 'prospecting-workspace-access'
  },
  [LANDING_PAGES_SHORT_ID_QA]: {
    toolPath: 'prospecting',
    upgradePoint: 'sales-workspace-academy',
    scope: 'prospecting-workspace-access'
  }
};
export const SHORT_IDS_PRACTICE_MODE_QA = [LANDING_PAGES_SHORT_ID_QA];
export const SHORT_IDS_PRACTICE_MODE_PROD = [SALES_WORKSPACE_ACADEMY_SHORT_ID, CREATE_LEADS_ACADEMY_SHORT_ID];
export const getPracticeModeConfig = shortId => {
  return PRACTICE_MODE_CONFIG[shortId] || null;
};